<template>
  <div v-if="open" class="confirm-overlay">
    <div class="confirm-card">
      <div class="confirm-title">{{ title }}</div>
      <div class="confirm-actions">
        <button class="link link-inline confirm-link" type="button" @click="$emit('close')">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NoticeModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'Fechar'
    }
  },
  emits: ['close']
})
</script>

<style scoped lang="scss">
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  display: grid;
  place-items: center;
  z-index: 60;
}

.confirm-card {
  min-width: min(620px, calc(100vw - 32px));
  background: #4f3300;
  color: #f3ede3;
  border-radius: 14px;
  border: 1px solid rgba(243, 237, 227, 0.2);
  padding: 18px 20px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25);
}

.confirm-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 14px;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 14px;
}

.link {
  background: transparent;
  border: none;
  cursor: pointer;
}

.link-inline {
  padding: 6px 10px;
}

.confirm-link {
  color: #f3ede3;
}

.confirm-link:hover {
  color: #b8dbff;
}
</style>

